module.exports = __webpack_public_path__ + "img/logo-fullsail.6ef37f22.svg";